import React, { useRef, useState } from 'react';
import { PiDotsThreeOutlineVerticalFill } from 'react-icons/pi';

import Modal from '../base/Modal';
import useClickOutside from '../../hooks/useClickOutside';
const GroupsModal = ({ isOpen, onClose, openAddGroup }) => {
  const allGroups = [
    {
      id: 1,
      title: 'My group',
      desc: '',
      apps: [
        {
          id: 1,
          label: 'Jira',
          value: 'jira',
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228864/mentorEducationImages/x3hajcpo5sbpdb0klxvu.png',
          functions: [
            'MANAGE Issues',
            'MANAGE Watchers',
            'MANAGE Comments',
            'MANAGE Jira Projects',
            'CREATE Issue Type',
            'DELETE Issue Type',
          ],
          unique_index: 0,
          selectedFunctions: [
            'CREATE Issue Type',
            'MANAGE Issues',
            'DELETE Issue Type',
            'MANAGE Watchers',
            'MANAGE Comments',
            'MANAGE Jira Projects',
          ],
        },
        {
          id: 2,
          label: 'Google Calendar',
          value: 'google_calendar',
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228690/mentorEducationImages/z9uxgo6owonunaeawede.png',
          functions: [
            'MANAGE Events',
            'MANAGE Calendars',
            'MANAGE Google Meet',
          ],
          unique_index: 1,
          selectedFunctions: [
            'MANAGE Calendars',
            'MANAGE Google Meet',
            'MANAGE Events',
          ],
        },
        {
          id: 14,
          label: 'Teams',
          value: 'teams',
          function: [],
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457135/mentorEducationImages/vr3wpu2bzwdhyqd9hq19.png',
          unique_index: 10,
          selectedFunctions: [],
        },
        {
          id: 6,
          label: 'Google Keep',
          value: 'google_keep',
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1727611983/mentorexperienceImages/mrmv6hsx7crykznjg7dp.png',
          functions: ['Note Management'],
        },
        {
          id: 13,
          label: 'Linear',
          value: 'linear',
          function: [],
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457317/mentorEducationImages/epy1xtlquycftuooe8vw.png',
        },
        {
          id: 14,
          label: 'Teams',
          value: 'teams',
          function: [],
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457135/mentorEducationImages/vr3wpu2bzwdhyqd9hq19.png',
        },
        {
          id: 15,
          label: 'Google tasks',
          value: 'google_tasks',
          function: [],
          image:
            'https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457121/mentorEducationImages/thywjdnrzkhqtp1caxrk.png',
        },
      ],
    },
  ];

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const toggleDropdown = (botId) => {
    setDropdownOpen((prev) => (prev === botId ? null : botId));
  };

  const dropdownRef = useRef(null);
  useClickOutside([dropdownRef], () => toggleDropdown(null));

  return (
    <Modal title="Groups" isOpen={isOpen} onClose={onClose}>
      <div className="flex min-h-96 flex-col justify-between gap-3 p-5 px-8">
        <div className="flex flex-1 flex-col gap-3 overflow-auto">
          {allGroups.map((item, index) => (
            <div
              key={index}
              className="relative flex cursor-pointer flex-col gap-2 rounded-md border border-zinc-700 bg-zinc-800 px-3 py-2 transition-colors duration-150 ease-in-out hover:border-neutral-600"
            >
              <div className="flex items-center">
                {item.apps.slice(0, 6).map((app, index) => (
                  <div
                    key={index}
                    className="-ml-2 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border border-zinc-700 bg-zinc-200 p-0.5"
                  >
                    <img
                      alt="Gmail: Add Label to Email"
                      loading="lazy"
                      width="24"
                      height="24"
                      src={app.image}
                    />
                  </div>
                ))}
                <p className="ml-2 flex-1 truncate text-sm font-medium">
                  {item.title}
                </p>
                <div className="relative z-10 flex gap-1">
                  <button
                    onClick={() => toggleDropdown(item.id)}
                    className="text-md -mr-1 flex items-center rounded-[3px] border-0 bg-transparent px-1 py-1 font-semibold text-zinc-300 transition-colors duration-150 ease-in-out hover:bg-zinc-700 disabled:cursor-not-allowed"
                  >
                    <PiDotsThreeOutlineVerticalFill className="text-xl" />
                  </button>
                </div>
                {dropdownOpen === item.id && (
                  <div
                    className="bg-1 br-1 text-s-text absolute right-0 top-10 z-20 w-48 rounded-xl border p-2"
                    ref={dropdownRef}
                  >
                    <button className="bg-1-hover block w-full rounded-xl px-4 py-2 text-left text-sm">
                      Duplicate Group
                    </button>
                    <button
                      onClick={() => {
                        openAddGroup();
                        onClose();
                        setDropdownOpen(null);
                      }}
                      className="bg-1-hover block w-full rounded-xl px-4 py-2 text-left text-sm"
                    >
                      Edit
                    </button>
                    <button className="bg-1-hover block w-full rounded-xl px-4 py-2 text-left text-sm">
                      Share
                    </button>
                    <button className="bg-1-hover block w-full rounded-xl px-4 py-2 text-left text-sm">
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div>
          <button
            onClick={() => {
              openAddGroup();
              onClose();
            }}
            className="rounded-lg border border-zinc-700 bg-zinc-800 px-3 py-1 text-sm"
          >
            + Add Group
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GroupsModal;
